var map = {
	"./Pear.svg": 378,
	"./asscher.svg": 379,
	"./backspace.svg": 380,
	"./baguette.svg": 381,
	"./briolette.svg": 382,
	"./calf.svg": 383,
	"./cushion_all.svg": 384,
	"./cushion_brill.svg": 385,
	"./cushion_mod.svg": 386,
	"./emerald.svg": 387,
	"./european.svg": 388,
	"./flanders.svg": 389,
	"./half_moon.svg": 390,
	"./heart.svg": 391,
	"./hexagonal.svg": 392,
	"./icon-arrow-right.svg": 393,
	"./icon-arrow.svg": 394,
	"./icon-calculator.svg": 395,
	"./icon-cart.svg": 396,
	"./icon-check.svg": 397,
	"./icon-copy.svg": 398,
	"./icon-cross.svg": 399,
	"./icon-currency.svg": 400,
	"./icon-delivery.svg": 401,
	"./icon-diamond-ring-step.svg": 402,
	"./icon-diamond-step.svg": 403,
	"./icon-diamond.svg": 404,
	"./icon-heart-red.svg": 405,
	"./icon-heart.svg": 406,
	"./icon-lk.svg": 407,
	"./icon-loop.svg": 408,
	"./icon-price.svg": 409,
	"./icon-register-big.svg": 410,
	"./icon-register.svg": 411,
	"./icon-ring-step.svg": 412,
	"./icon-tel.svg": 413,
	"./icon-triangle.svg": 414,
	"./icon-xmark-solid.svg": 415,
	"./kite.svg": 416,
	"./logo-gems-market-blue.svg": 417,
	"./logo-gems-market-gray.svg": 418,
	"./logo-gems-market-white.svg": 419,
	"./lozenge.svg": 420,
	"./marquise.svg": 421,
	"./octagonal.svg": 422,
	"./old_miner.svg": 423,
	"./oval.svg": 424,
	"./pentagonal.svg": 425,
	"./princess.svg": 426,
	"./radiant.svg": 427,
	"./rapnet-red.svg": 428,
	"./rose.svg": 429,
	"./round.svg": 430,
	"./sq_emerald.svg": 431,
	"./sq_radiant.svg": 432,
	"./square.svg": 433,
	"./star.svg": 434,
	"./tapered_baguet.svg": 435,
	"./tapered_bull.svg": 436,
	"./trapezoid.svg": 437,
	"./triangular.svg": 438,
	"./trilliant.svg": 439
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 377;